<template>
  <b-row>
    <b-col sm>
      <b-pagination
        v-if="pagination.documents > pagination.perPage"
        align="center"
        v-model="pagination.currentPage"
        :total-rows="pagination.documents"
        :per-page="pagination.perPage"
      ></b-pagination>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: "component-pagination",
  props: { pagination: { type: Object } },
};
</script>

<style>
</style>s


// WEBPACK FOOTER //
// src/components/shared/pagination.vue